import { useMutation } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import useModal from 'ui/partials/Modal/useModal';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';

export default function useOutlookSendMail() {
  const { hideModal } = useModal();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useMutation({
    mutationFn: async (payload: Record<string, any>) => {
      const api = new Api(args);

      const data = await api.post(
        await withAcl({
          account: {
            url: `api/v1/channels/azure/mail/send`,
            payload,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/channels/azure/mail/send`,
            payload,
          },
        }),
      );

      return data;
    },
    onSuccess: () => {
      hideModal();
      toastSuccess('Successfully sent mail');
    },
  });
}
